import { create } from 'zustand';
import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = '@releaseNotes:lastSeenDate';

const useReleaseNotesStore = create((set, get) => ({
    lastSeenDate: null,
    hasUnread: false,

    init: async () => {
        try {
            const stored = await AsyncStorage.getItem(STORAGE_KEY);
            set({ lastSeenDate: stored || null });
        } catch {
            set({ lastSeenDate: null });
        }
    },

    checkUnread: (latestDate) => {
        const { lastSeenDate } = get();
        const hasUnread = !!latestDate && latestDate !== lastSeenDate;
        set({ hasUnread });
    },

    markAsSeen: async (date) => {
        try {
            await AsyncStorage.setItem(STORAGE_KEY, date);
            set({ lastSeenDate: date, hasUnread: false });
        } catch {
            // silently fail
        }
    },
}));

export default useReleaseNotesStore;
